import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { useServices } from "@core/servicesContext";
import { DeleteIcon } from "./icons";
import { row } from "./layout";

const loadingAnimation = keyframes`
	0%{background-position:0% 0%}
	100%{background-position:89% 89%}
`;

interface LoadingBarProps extends React.HTMLAttributes<HTMLDivElement> {
	progress: number;
}
export const LoadingBar: React.FC<LoadingBarProps> = ({ progress, ...htmlProps }) => {
	const { mediaService } = useServices();
	const [canceling, setCanceling] = useState(false);

	return (
		<Container {...htmlProps}>
			<ProgressBar progress={progress} canceling={canceling} />
			<DeleteIcon
				onClick={() => {
					setCanceling(true);
					mediaService.cancelUpload();
				}}
			/>
		</Container>
	);
};

const Container = styled.div`
	${row(10, "flex-start", "center")};
	align-self: stretch;
	> :first-child {
		flex: 1;
	}
	svg {
		cursor: pointer;
		flex-shrink: 0;
		width: 20px;
		height: 20px;
	}
`;

const ProgressBar = styled.div.attrs<{ progress: number }>((props) => ({
	style: {
		transform: `scaleX(${props.progress})`,
	},
}))<{ progress: number; canceling?: boolean }>`
	transition: transform ease-out 0.2s;
	border-radius: 9px;
	align-self: stretch;
	height: 20px;
	background: ${({ canceling, theme }) =>
		`linear-gradient(313deg, ${theme.colors.white}, ${canceling ? theme.colors.red : theme.colors.secondary}, ${
			theme.colors.white
		}, ${canceling ? theme.colors.red : theme.colors.secondary})`};
	background-size: 400% 400%;
	animation: ${loadingAnimation} ease-in-out infinite 2s both;
	transform-origin: 0;
`;
